import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import { Context, ScoresSchema, StudyPlanTargets, Transitions } from "../types"
import {
  downloadScoresByStudentTransition,
  getScoresByStudentTransition
} from "./admin/transitionalStates"
import { setRedirectUrl } from "../actions/setRedirectUrl"

export const studyPlansScores: StateNodeConfig<
  Context,
  ScoresSchema,
  Transitions,
  BaseActionObject
> = {
  id: "study_plans_scores",
  entry: [
    assign((ctx, evt, meta) => {
      if (ctx.previousParentState !== "study_plans_scores") {
        return setRedirectUrl(ctx, evt, meta, StudyPlanTargets.Scores)
      }
    }),
    assign((_ctx, _evt) => {
      return {
        previousParentState: "study_plans_scores",
        currentTarget: StudyPlanTargets.Scores
      }
    })
  ],

  initial: "get_scores_by_student",
  states: {
    idle: {
      on: {
        GET_SCORES_BY_STUDENT: {
          target: "get_scores_by_student"
        },
        DOWNLOAD_SCORES_BY_STUDENT: {
          target: "download_scores_by_student"
        }
      }
    },
    get_scores_by_student: { ...getScoresByStudentTransition },
    download_scores_by_student: { ...downloadScoresByStudentTransition }
  }
}
